import firebase from './firebase'

const ACCOUNT_EXISTS_WITH_OTHER_CREDENTIAL = 'auth/account-exists-with-different-credential';
const ACCOUNT_EXISTS = 'auth/email-already-in-use';
const WRONG_PASSWORD = 'auth/wrong-password';
const USER_DISABLED = 'auth/user-disabled';
const USER_NOT_FOUND = 'auth/user-not-found';

const supportedPopupSignInMethods = [
    firebase.auth.GoogleAuthProvider.PROVIDER_ID,
    firebase.auth.FacebookAuthProvider.PROVIDER_ID,
    firebase.auth.EmailAuthProvider.PROVIDER_ID
];

function getProvider (providerId) {
    switch (providerId) {
      case firebase.auth.GoogleAuthProvider.PROVIDER_ID:
        return new firebase.auth.GoogleAuthProvider();
      case firebase.auth.FacebookAuthProvider.PROVIDER_ID:
        return new firebase.auth.FacebookAuthProvider();
      default:
        throw new Error(`No provider implemented for ${providerId}`);
    }
}

async function fetchExistingProvider(email) {
    const providers = await firebase.auth().fetchSignInMethodsForEmail(email);
    const firstPopupProviderMethod = providers.find(p => supportedPopupSignInMethods.includes(p));
    if (firstPopupProviderMethod == firebase.auth.EmailAuthProvider.PROVIDER_ID)
        throw new Error('Conta já existe!');
    if (!firstPopupProviderMethod)
        throw new Error('Provedor cadastrado não é mais o mesmo.');
    return getProvider(firstPopupProviderMethod);
}

async function resolveProviderConflict (email, credential, password) {
    const existingProvider = await fetchExistingProvider(email);
  
    existingProvider.setCustomParameters({ login_hint: email, });
  
    const result = await firebase.auth().signInWithPopup(existingProvider);
    const { user } = await result.user.linkWithCredential(credential);
    await user.updatePassword(password);
    return user;
}

async function associateAsEmailAccount (email, password) {
    const existingProvider = await fetchExistingProvider(email);
    const { user } = await firebase.auth().signInWithPopup(existingProvider);
    await user.updatePassword(password);
    return user;
}

export async function createEmailPasswordUser (email, password, name) {
    try {
        let { user } = await firebase.auth().createUserWithEmailAndPassword(email, password);
        if (name) {
            await user.updateProfile({
                displayName: name
            })
        }
        return user;
    } catch (err) {
        if (err.code == ACCOUNT_EXISTS) // todo associate in other way...
            return associateAsEmailAccount(email, password);
        if (err.email && err.credential && err.code === ACCOUNT_EXISTS_WITH_OTHER_CREDENTIAL)
            return resolveProviderConflict(err.email, err.credential, password);
        else throw err;
    }
}

export async function verifyEmailInUse (email) {
    try {
        await firebase.auth().signInWithEmailAndPassword(email, '');
    } catch (err) {
        if (err.code == WRONG_PASSWORD || err.code == USER_DISABLED)
            return true;
        else if (err.code == USER_NOT_FOUND)
            return false;
        throw new Error(`Erro desconhecido - Detalhe: ${err.message}`);
    }
}
